import React, { useRef } from 'react';
import { SVG, Icons } from '../../../components/atoms/SVG';
import { Tooltip, TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import bem from '../../../lib/bemUtils/bem';

interface ResetButtonProps {
  onClick: (event: React.FormEvent) => void;
  focus: boolean;
  hasInputValue: boolean;
}

export function SearchFormResetButton({ onClick, focus, hasInputValue }: ResetButtonProps) {
  const { t } = useSonTranslation('SearchForm');
  const buttonRef = useRef<HTMLButtonElement>(null);

  const isVisible = focus && hasInputValue;

  return (
    <Tooltip attachTo={buttonRef} placement={TooltipPlacement.BOTTOM}>
      <span className={bem('search-form__reset-wrapper', [isVisible ? 'visible' : 'invisible'])}>
        <button
          type="reset"
          ref={buttonRef}
          className="search-form__reset"
          title={t('search.deletesearch')}
          tabIndex={isVisible ? 0 : -1}
          onClick={onClick}
          aria-label={t('search.deletesearch')}
        >
          <span className="invisible">{t('search.deletesearch')}</span>
          <SVG svgSpriteId={Icons.DECLINE_CROSS} inverted svgClass="search-form__svg-reset" />
        </button>
      </span>
    </Tooltip>
  );
}
